import React from "react";
import { Link } from "react-router-dom";
import usdaLogo from "assets/img/usda-symbol.svg";
import fsLogo from "assets/img/usfslogo.svg";
import twitterLogo from "assets/img/social-icon-twitter.svg";
import facebookLogo from "assets/img/social-icon-facebook.svg";
import youtubeLogo from "assets/img/social-icon-youtube.svg";
import flickrLogo from "assets/img/social-icon-flickr.svg";
import instagramLogo from "assets/img/social-icon-instagram.svg";
import "./Footer.css";

const Footer = (props) => {
  return (
    <footer className="usa-footer footer-container">
      <div className="grid-container usa-footer__return-to-top">
        <a style={{ width: "24px !important" }} href="#">
          Return to top
        </a>
      </div>
      <div className="usa-footer__primary-section">
        <nav className="usa-footer__nav">
          <ul className="grid-row grid-gap">
            <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
              <Link className="usa-footer__primary-link" to="/home">
                Home
              </Link>
            </li>
            <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
              <Link className="usa-footer__primary-link" to="/map">
                Interactive Map
              </Link>
            </li>
            <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
              <Link className="usa-footer__primary-link" to="/pest-information">
                Pest Information
              </Link>
            </li>
            <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
              <Link className="usa-footer__primary-link" to="/national-reports">
                National Reports
              </Link>
            </li>
            <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
              <Link className="usa-footer__primary-link" to="/contact">
                Contacts
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="gray-background">
        <div className="footer-secondary-section">
          <div className="grid-container">
            <div className="grid-row grid-gap">
              <div className="grid-col-fill">
                <div className="region-footer">
                  <div
                    id="block-fs-uswds-requiredfootermenu"
                    className="block block-menu-block block-menu-block:black-footer-menu"
                  >
                    <ul className="menu menu--black-footer-menu nav footer-menu">
                      <li>
                        <a
                          href="https://ask.usda.gov/s/?utm_source=USDA&utm_medium=homepage&utm_campaign=homepage%20referrals"
                          target="_blank"
                          rel="noreferrer"
                        >
                          askUSDA
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://ask.usda.gov/s/contactsupport"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/sitemap"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Site Map
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/policies-and-links"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Policies &amp; Links
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/our-agency/about-usda/performance"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Our Performance
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/our-agency/careers"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Careers
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://usdaoig.oversight.gov/resources/contractor-fraud"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Report Fraud on USDA Contracts
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://usdaoig.oversight.gov/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Visit OIG
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/plain-writing"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Plain Writing
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/open"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Open Government
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/ogc/office-information-affairs/foia-division"
                          target="_blank"
                          rel="noreferrer"
                        >
                          FOIA
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/accessibility-statement"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Accessibility Statement
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/privacy-policy"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/non-discrimination-statement"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Non-Discrimination Statement
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/oascr/civil-rights-statements"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Anti-Harassment Policy
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/ocio/guidelines-and-compliance-resources/information-quality-activities"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Information Quality
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usa.gov/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          USA.gov
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.whitehouse.gov/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Whitehouse.gov
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/federal-web-site-inventory"
                          target="_blank"
                          rel="noreferrer"
                        >
                          eGov
                        </a>
                      </li>
                      <li>
                        <a
                          href="mailto:feedback@oc.usda.gov"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Feedback
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.usda.gov/nofear"
                          target="_blank"
                          rel="noreferrer"
                        >
                          No FEAR Act Data
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-third-section">
          <div className="footer-branding-container">
            <a href="https://www.usda.gov" target="_blank" rel="noreferrer">
              <img
                className="usda-logo"
                src={usdaLogo}
                alt="U.S. Department of Agriculture"
              />
            </a>
            <a href="https://www.fs.usda.gov/" target="_blank" rel="noreferrer">
              <img className="fs-logo" src={fsLogo} alt="U.S. Forest Service" />
            </a>
            <div className="fs-usda-container desktop">
              <div>
                <span className="fs-name">Forest Service</span>
              </div>
              <div className="usda-name">U.S. DEPARTMENT OF AGRICULTURE</div>
            </div>
          </div>
          <div className="social-links">
            <a href="https://twitter.com/forestservice" className="social-link">
              <img
                src={twitterLogo}
                alt="Twitter"
                target="_blank"
                rel="noreferrer"
                className="usa-social-image"
              />
            </a>
            <a
              href="https://www.facebook.com/USForestService/"
              className="social-link"
            >
              <img
                src={facebookLogo}
                alt="Facebook"
                target="_blank"
                rel="noreferrer"
                className="usa-social-image"
              />
            </a>
            <a
              href="https://www.youtube.com/user/usdaForestService"
              className="social-link"
            >
              <img
                src={youtubeLogo}
                alt="YouTube"
                target="_blank"
                rel="noreferrer"
                className="usa-social-image"
              />
            </a>
            <a
              href="https://www.flickr.com/photos/usforestservice/"
              className="social-link"
            >
              <img
                src={flickrLogo}
                alt="Flickr"
                target="_blank"
                rel="noreferrer"
                className="usa-social-image"
              />
            </a>
            <a
              href="https://www.instagram.com/u.s.forestservice/"
              className="social-link"
            >
              <img
                src={instagramLogo}
                alt="Instagram"
                target="_blank"
                rel="noreferrer"
                className="usa-social-image"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
